import { gql } from "@apollo/client"

// Returns boolean from postgres
export const CREATE_UPDATE_CUSTOM_REPORT = gql`
  mutation createOrUpdateCustomReport($data: CreateOrUpdateCustomReportInput!) {
    customReports {
      createOrUpdateCustomReport(data: $data)
    }
  }
`

export const DELETE_CUSTOM_REPORT = gql`
  mutation deleteCustomReport($data: DeleteCustomReportInput!) {
    customReports {
      deleteCustomReport(data: $data)
    }
  }
`

export const GET_CUSTOM_REPORT = gql`
  query getCustomReport($data: GetCustomReportInput!) {
    customReports {
      getCustomReport(data: $data) {
        name
        settings
        generate_data
        reportType
      }
    }
  }
`
